import { render, staticRenderFns } from "./ProgramCustomizationLogin.vue?vue&type=template&id=1bc58f21&lang=pug&"
import script from "./ProgramCustomizationLogin.vue?vue&type=script&lang=js&"
export * from "./ProgramCustomizationLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports